"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingItemWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const setting_item_title_1 = require("./setting-item-title");
exports.SettingItemWrapper = (0, react_1.memo)(({ title, description, children, sx, divier = true, }) => {
    const theme = (0, material_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "column", spacing: 2, width: "100%", sx: Object.assign({}, sx), children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", width: "100%", justifyContent: "space-between", children: [(0, jsx_runtime_1.jsx)(setting_item_title_1.SettingItemTitle, { title: title, description: description, sx: {
                            flex: 1,
                            justifyContent: "start",
                        } }), (0, jsx_runtime_1.jsx)(material_1.Stack, { flex: 2, justifyContent: "end", children: children })] }), divier && ((0, jsx_runtime_1.jsx)(material_1.Divider, { sx: {
                    width: "100%",
                    margin: theme.spacing(2, 0),
                } }))] }));
});
exports.SettingItemWrapper.displayName = "SettingItemWrapper";
